import { render, staticRenderFns } from "./twoBar.vue?vue&type=template&id=f545d84a"
import script from "./twoBar.vue?vue&type=script&lang=js"
export * from "./twoBar.vue?vue&type=script&lang=js"
import style0 from "./twoBar.vue?vue&type=style&index=0&id=f545d84a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports